import { serviceInstance } from 'libs';

export default {
  requestTerminal: (body) =>
    serviceInstance.post(`/v1/terminal-request`, body).then(({ data }) => ({
      ...data,
    })),

  getTerminalPrice: () =>
    serviceInstance
      .get(`/v1/terminal-request/price?posRequestType=LEASE`)
      .then(({ data }) => ({
        ...data,
      })),
  fetchTerminals: (params) =>
    serviceInstance
      .get(`/v1/merchant-terminal`, { params })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  getTerminalRequests: (params) =>
    serviceInstance
      .get(`/v1/terminal-request`, { params })
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
  activateTerminal: (params) =>
    serviceInstance
      .post(`/v1/merchant-terminal`, params)
      .then(({ data, status }) => ({
        ...data,
        status,
      })),
};
